<template>
	<div class="home">
		<!--eslint-disable-next-line prettier/prettier-->
		<web-text :level="4" color="gray" weight="md" size="xs" customClass="mb-6"></web-text>
		<!--eslint-disable-next-line prettier/prettier-->
		<div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
			<!--eslint-disable-next-line prettier/prettier-->
			<basic-box :level="2" color="gray" size="custom" customClass="w-full h-full p-4">
				<!--eslint-disable-next-line prettier/prettier-->
				<web-text :level="4" color="gray" weight="sm" size="sm" customClass="mb-6"></web-text>
				<basic-circle
					:level="2"
					color="blue"
					size="xl"
					customClass="mx-auto mb-4"
				></basic-circle>
				<web-text
					:level="3"
					color="gray"
					weight="sm"
					size="lg"
					customClass="mx-auto mb-2"
				></web-text>
			</basic-box>
			<!--eslint-disable-next-line prettier/prettier-->
			<basic-box :level="2" color="gray" size="custom" customClass="w-full h-full p-4">
				<!--eslint-disable-next-line prettier/prettier-->
				<web-text :level="4" color="gray" weight="sm" size="sm" customClass="mb-6"></web-text>
				<basic-box
					:level="2"
					color="blue"
					size="xl"
					customClass="mx-auto mb-4"
				></basic-box>
				<web-text
					:level="3"
					color="gray"
					weight="sm"
					size="lg"
					customClass="mx-auto mb-2"
				></web-text>
			</basic-box>
			<!--eslint-disable-next-line prettier/prettier-->
			<basic-box :level="2" color="gray" size="custom" customClass="w-full h-full p-4">
				<!--eslint-disable-next-line prettier/prettier-->
				<web-text :level="4" color="gray" weight="sm" size="sm" customClass="mb-6"></web-text>
				<basic-triangle
					:level="2"
					color="blue"
					size="xl"
					customClass="mx-auto mb-4"
				></basic-triangle>
				<web-text
					:level="3"
					color="gray"
					weight="sm"
					size="lg"
					customClass="mx-auto mb-2"
				></web-text>
			</basic-box>
			<!--eslint-disable-next-line prettier/prettier-->
			<basic-box :level="2" color="gray" size="custom" customClass="w-full h-full p-4">
				<!--eslint-disable-next-line prettier/prettier-->
				<web-text :level="4" color="gray" weight="sm" size="sm" customClass="mb-6"></web-text>
				<basic-triangle
					:level="2"
					color="blue"
					size="xl"
					customClass="mx-auto mb-4"
				></basic-triangle>
				<web-text
					:level="3"
					color="gray"
					weight="sm"
					size="lg"
					customClass="mx-auto mb-2"
				></web-text>
			</basic-box>
			<!--eslint-disable-next-line prettier/prettier-->
			<basic-box :level="2" color="gray" size="custom" customClass="w-full h-full p-4">
				<!--eslint-disable-next-line prettier/prettier-->
				<web-text :level="4" color="gray" weight="sm" size="sm" customClass="mb-6"></web-text>
				<basic-circle
					:level="2"
					color="blue"
					size="xl"
					customClass="mx-auto mb-4"
				></basic-circle>
				<web-text
					:level="3"
					color="gray"
					weight="sm"
					size="lg"
					customClass="mx-auto mb-2"
				></web-text>
			</basic-box>
			<!--eslint-disable-next-line prettier/prettier-->
			<basic-box :level="2" color="gray" size="custom" customClass="w-full h-full p-4">
				<!--eslint-disable-next-line prettier/prettier-->
				<web-text :level="4" color="gray" weight="sm" size="sm" customClass="mb-6"></web-text>
				<basic-box
					:level="2"
					color="blue"
					size="xl"
					customClass="mx-auto mb-4"
				></basic-box>
				<web-text
					:level="3"
					color="gray"
					weight="sm"
					size="lg"
					customClass="mx-auto mb-2"
				></web-text>
			</basic-box>
			<!--eslint-disable-next-line prettier/prettier-->
			<basic-box :level="2" color="gray" size="custom" customClass="md:col-span-2 w-full h-full p-4">
				<!--eslint-disable-next-line prettier/prettier-->
				<web-text :level="4" color="gray" weight="sm" size="sm" customClass="mb-6"></web-text>
				<web-text
					:level="3"
					color="gray"
					weight="sm"
					size="xl"
					customClass="mb-2"
				></web-text>
				<web-text
					:level="3"
					color="gray"
					weight="sm"
					size="xl"
					customClass="mb-2"
				></web-text>
				<web-text
					:level="3"
					color="gray"
					weight="sm"
					size="xl"
					customClass="mb-2"
				></web-text>
				<web-text
					:level="3"
					color="gray"
					weight="sm"
					size="lg"
					customClass="mb-6"
				></web-text>
			</basic-box>
			<!--eslint-disable-next-line prettier/prettier-->
			<basic-box :level="2" color="gray" size="custom" customClass="md:col-span-2 lg:col-span-1 w-full h-full p-4">
				<!--eslint-disable-next-line prettier/prettier-->
				<web-text :level="4" color="gray" weight="sm" size="sm" customClass="mb-6"></web-text>
				<!--eslint-disable-next-line prettier/prettier-->
				<basic-container customClass="flex flex-rows items-center justify-center w-full h-auto">
					<basic-triangle
						:level="2"
						color="blue"
						size="xl"
						customClass="mx-2"
					></basic-triangle>
					<basic-box
						:level="2"
						color="blue"
						size="xl"
						customClass="mx-2"
					></basic-box>
					<basic-circle
						:level="2"
						color="blue"
						size="xl"
						customClass="mx-2"
					></basic-circle>
				</basic-container>
				<web-text
					:level="3"
					color="gray"
					weight="sm"
					size="lg"
					customClass="mb-2"
				></web-text>
			</basic-box>
			<!--eslint-disable-next-line prettier/prettier-->
			<basic-box :level="2" color="gray" size="custom" customClass="md:row-span-2 md:col-span-2 w-full h-full p-4">
				<!--eslint-disable-next-line prettier/prettier-->
				<web-text :level="4" color="gray" weight="sm" size="sm" customClass="mb-6"></web-text>
				<web-text
					:level="3"
					color="gray"
					weight="sm"
					size="xl"
					customClass="mb-2"
				></web-text>
				<web-text
					:level="3"
					color="gray"
					weight="sm"
					size="xl"
					customClass="mb-2"
				></web-text>
				<web-text
					:level="3"
					color="gray"
					weight="sm"
					size="xl"
					customClass="mb-2"
				></web-text>
				<web-text
					:level="3"
					color="gray"
					weight="sm"
					size="lg"
					customClass="mb-6"
				></web-text>
				<web-text
					:level="3"
					color="gray"
					weight="sm"
					size="xl"
					customClass="mb-2"
				></web-text>
				<web-text
					:level="3"
					color="gray"
					weight="sm"
					size="xl"
					customClass="mb-2"
				></web-text>
				<web-text
					:level="3"
					color="gray"
					weight="sm"
					size="xl"
					customClass="mb-2"
				></web-text>
				<web-text
					:level="3"
					color="gray"
					weight="sm"
					size="lg"
					customClass="mb-6"
				></web-text>
				<web-text
					:level="3"
					color="gray"
					weight="sm"
					size="xl"
					customClass="mb-2"
				></web-text>
				<web-text
					:level="3"
					color="gray"
					weight="sm"
					size="xl"
					customClass="mb-2"
				></web-text>
				<web-text
					:level="3"
					color="gray"
					weight="sm"
					size="xl"
					customClass="mb-2"
				></web-text>
				<web-text
					:level="3"
					color="gray"
					weight="sm"
					size="lg"
					customClass="mb-6"
				></web-text>
			</basic-box>
			<!--eslint-disable-next-line prettier/prettier-->
			<basic-box :level="2" color="gray" size="custom" customClass="md:col-span-2 lg:col-span-1 w-full h-full p-4">
				<!--eslint-disable-next-line prettier/prettier-->
				<web-text :level="4" color="gray" weight="sm" size="sm" customClass="mb-6"></web-text>
				<basic-circle
					:level="2"
					color="blue"
					size="xl"
					customClass="mx-auto mb-4"
				></basic-circle>
				<web-text
					:level="3"
					color="gray"
					weight="sm"
					size="lg"
					customClass="mx-auto mb-2"
				></web-text>
			</basic-box>
			<!--eslint-disable-next-line prettier/prettier-->
			<basic-box :level="2" color="gray" size="custom" customClass="md:col-span-2 lg:col-span-1 w-full h-full p-4">
				<!--eslint-disable-next-line prettier/prettier-->
				<web-text :level="4" color="gray" weight="sm" size="sm" customClass="mb-6"></web-text>
				<basic-triangle
					:level="2"
					color="blue"
					size="xl"
					customClass="mx-auto mb-4"
				></basic-triangle>
				<web-text
					:level="3"
					color="gray"
					weight="sm"
					size="lg"
					customClass="mx-auto mb-2"
				></web-text>
			</basic-box>
			<!--eslint-disable-next-line prettier/prettier-->
			<basic-box :level="2" color="gray" size="custom" customClass="md:col-span-2 lg:col-span-1 w-full h-full p-4" >
				<!--eslint-disable-next-line prettier/prettier-->
				<web-text :level="4" color="gray" weight="sm" size="sm" customClass="mb-16"></web-text>
				<basic-box
					:level="2"
					color="blue"
					size="xl"
					customClass="mx-auto mb-16"
				></basic-box>
				<web-text
					:level="3"
					color="gray"
					weight="sm"
					size="lg"
					customClass="mx-auto mb-2"
				></web-text>
			</basic-box>
			<!--eslint-disable-next-line prettier/prettier-->
			<basic-box :level="2" color="gray" size="custom" customClass="md:col-span-2 w-full h-full p-4" >
				<!--eslint-disable-next-line prettier/prettier-->
				<web-text :level="4" color="gray" weight="sm" size="sm" customClass="mb-6"></web-text>
				<web-text
					:level="3"
					color="gray"
					weight="sm"
					size="xl"
					customClass="mb-2"
				></web-text>
				<web-text
					:level="3"
					color="gray"
					weight="sm"
					size="xl"
					customClass="mb-2"
				></web-text>
				<web-text
					:level="3"
					color="gray"
					weight="sm"
					size="lg"
					customClass="mb-6"
				></web-text>
				<web-text
					:level="3"
					color="gray"
					weight="sm"
					size="xl"
					customClass="mb-2"
				></web-text>
				<web-text
					:level="3"
					color="gray"
					weight="sm"
					size="xl"
					customClass="mb-2"
				></web-text>
				<web-text
					:level="3"
					color="gray"
					weight="sm"
					size="lg"
					customClass="mb-6"
				></web-text>
				<web-text
					:level="3"
					color="gray"
					weight="sm"
					size="xl"
					customClass="mb-2"
				></web-text>
				<web-text
					:level="3"
					color="gray"
					weight="sm"
					size="xl"
					customClass="mb-2"
				></web-text>
				<web-text
					:level="3"
					color="gray"
					weight="sm"
					size="lg"
					customClass="mb-6"
				></web-text>
			</basic-box>
		</div>
	</div>
</template>

<script>
import BasicBox from '@/components/BasicBox.vue';
import BasicCircle from '@/components/BasicCircle.vue';
import BasicTriangle from '@/components/BasicTriangle.vue';
import BasicContainer from '@/components/BasicCircle';
import WebText from '@/components/WebText.vue';

export default {
	name: 'Home',
	components: {
		BasicBox,
		BasicCircle,
		BasicTriangle,
		BasicContainer,
		WebText,
	},
};
</script>
